import { Close } from '@mui/icons-material'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import CustomButton from 'components/Fileds/CustomButton'
import CustomTypography from 'components/Fileds/CustomTypography'
import React from 'react'

const AddOnsView = ({ onClose, open, selectedItemAddons, selectedOrderItem }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            className="order-items-form-dialog"
            PaperProps={{
                sx: {
                    width: "450px",
                    padding: "20px 0px 30px 0px",
                    borderRadius: "20px",
                    backgroundColor: "white",
                },
            }}
        >
            <IconButton aria-label="close" onClick={onClose} className="close-icon">
                <Close />
            </IconButton>
            <DialogTitle sx={{ pb: 0 }}>
                <CustomTypography variant="h5" component={"div"}
                    label={`${selectedOrderItem?.menu_item_name}'s Add-ons`}
                    sx={{
                        fontSize: '20px', fontWeight: 700,
                    }}
                />
            </DialogTitle>

            <DialogContent>
                <Box component="ul" sx={{ pl: 2, m: 0, alignContent: 'center', lineHeight: 1, height: '100%' }}>
                    {selectedItemAddons.map((addon, idx) => (
                        <li key={idx} style={{ listStyleType: "disc" }}>
                            <Typography key={idx} sx={{ mb: 1, fontSize: '15px' }}>
                                {addon.addon_name}
                            </Typography>
                        </li>
                    ))}
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default AddOnsView
